export const tablasMixin = {
	data: function() {
		return {
			tableProps: {
				border: true,
				stripe: true,
				defaultSort: {
					prop: undefined,
					order: 'descending'
				},
				//highlightCurrentRow: true,
				rowClassName({ row, rowIndex }) {
					return 'estiloFilaTabla';
				}
			}
		}
	}
};
